import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Transforms the ip_information criteria from WooRank API response
 * @param {Object} ipInformationCriteria - criteria.ip_information
 * @returns {Object} - Transformed server IP data for React components
 */
export const transformServerIp = (ipInformationCriteria) => {
  // Missing criteria: treat as "not identified"
  if (!ipInformationCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'Not identified.',
      data: null,
    };
  }

  const data = ipInformationCriteria?.data || {};
  const wooRankStatus = ipInformationCriteria?.status || 'neutral';
  const importance = ipInformationCriteria?.importance || 0;
  const solvability = ipInformationCriteria?.solvability || 0;

  const ip = data?.ip || '';
  const cityName = data?.location?.cityName || '';

  const isEmpty = !ip;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'Not identified.' : null,
    data: isEmpty
      ? null
      : {
          ip,
          cityName,
        },
  };
};

export default transformServerIp;


